<script>
	import { onMount, createEventDispatcher, tick } from "svelte";
	import objectStore from "../store.js";
	import Tabs from "../Tabs.svelte";
	import Slide from "../Slide.svelte";
	import Registration from "./Registration.svelte";
	import Login from "./Login.svelte";

	export let langCode = "en";
	export let api;
	export let token;
	const dispatch = createEventDispatcher();

	let ready = false;
	let tabVal = 0;

	let register = false;
	let login = null;
	let back = false;

	$: curtab = tabVal;

	const tabs = [];
	const labels = [
		{ lang: "en", l1: "Login", l2: "Register" },
		{ lang: "es", l1: "Select", l2: "Choose" },
		{ lang: "pt", l1: "Select", l2: "Choose" },
		{ lang: "ar", l1: "Select", l2: "Choose" },
		{ lang: "nl", l1: "Select", l2: "Choose" },
		{ lang: "fr", l1: "Select", l2: "Choose" },
		{ lang: "it", l1: "Select", l2: "Choose" },
		{ lang: "ru", l1: "Select", l2: "Choose" },
		{ lang: "de", l1: "Select", l2: "Choose" },
		{ lang: "zh", l1: "Select", l2: "Choose" },
		{ lang: "jp", l1: "Select", l2: "Choose" },
	];

	onMount(() => {
		setLabels();
		ready = true;
	});
	async function toLogin() {
		tabVal = 0;
		register = false;
		login = true;
		back = true;
		await tick();
		back = false;
	}
	function handleBack() {
		objectStore.updateItem({
			available: true,
			back: true,
			sub: $objectStore.sub,
			domain: $objectStore.domain,
			plan: $objectStore.plan,
		});
		dispatch("back", {});
	}

	function setLabels() {
		const translations = labels.filter((x) => x.lang == langCode);

		if (translations.length == 0) {
			labels.filter((x) => x.lang == "en");
		}

		tabs.push({ label: translations[0].l1, name: "d" });
		tabs.push({ label: translations[0].l2, name: "d" });
	}
	async function tabChange(event) {
		console.log("tab change");
		console.log(event.detail.text);

		if (event.detail.text === 0) {
			register = false;
			login = true;
			back = true;
			await tick();
			back = false;
		} else {
			register = true;
			login = false;
		}
	}
</script>

{#if ready && $objectStore.available && $objectStore.plan}
	<!-- <div id="back" on:click={handleBack}>
		<svg class="svg-icon-back" x="0px" y="0px" viewBox="0 0 200 200"
			><path
				d="M101.55 40.58L101.55 40.58Q104.22 40.58 106.05 42.41L106.05 42.41Q107.73 44.09 107.73 46.48L107.73 46.48Q107.73 49.02 106.05 50.70L106.05 50.70L69.20 86.42L106.05 122.14Q107.73 123.83 107.73 126.36L107.73 126.36Q107.73 128.75 106.05 130.44L106.05 130.44Q104.22 132.13 101.55 132.13L101.55 132.13Q98.88 132.13 97.19 130.44L97.19 130.44L53.88 88.39Q52.89 87.55 52.89 86.42L52.89 86.42Q52.89 85.30 53.88 84.45L53.88 84.45L97.19 42.41Q98.88 40.58 101.55 40.58L101.55 40.58Z"
			/></svg
		>
	</div> -->
	<!-- <div class="tabs">
		<Tabs on:tabchange={tabChange} {tabs} tabVal={curtab} />
	</div> -->
	<!-- <div class="action"> -->
	<!-- <div class="shop" on:click={handleBack}>
			<span class="plan"
				>{$objectStore.plan.price} {$objectStore.plan.name}</span
			><br />
			<span class="domain">{$objectStore.sub + $objectStore.domain}</span>
		</div> -->
	<!-- <div class="shadow-box"> -->

	<!-- <Slide> -->
	<!-- <Slide slide={login} {back}> -->
	<Login {api} {token} on:back={handleBack}></Login>
	<!-- <Registration on:tologin={toLogin} {api} {token}></Registration> -->
	<!-- </Slide> -->

	<!-- </div> -->
	<!-- <Slide slide={register} {back}> -->
	<!-- </Slide> -->
	<!-- </Slide> -->
	<!-- </div> -->
{/if}

<style>
	.action {
		/* width: 100%; */
		height: 35px;
		padding-top: 20px;
		margin: 10%;
	}
	.tabs {
		width: 280px;
		height: 35px;
		padding-top: 20px;
		margin: auto;
	}

	/* #back {
		position: absolute;
		width: 35px;
		height: 35px;
		-webkit-tap-highlight-color: transparent;
		outline: none;
		cursor: pointer;
	} */

	.svg-icon-back {
		width: 35px;
		height: 35px;
		fill: #cccccc;
		margin-top: 35px;
		margin-left: 10px;
	}

	.shop {
		text-align: center;
		margin: 15px;
		margin-bottom: 0px;
		cursor: pointer;
		-webkit-tap-highlight-color: transparent;
	}

	.shop .plan {
		font-size: 16px;
		font-weight: 600;
		color: #007aff;
	}

	.shop .domain {
		font-size: 14px;
	}

	:global(#submitted) {
		text-align: center;
		position: absolute;
		width: 200px;
		left: calc(50% - 100px);
	}
</style>
